export const TabbedNavItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_tabbed_nav_item',
    model: null, // TabbedLayoutPageListItem
    className: 'tabbed_nav_item',
    tagName: 'a',
    attributes: {
        href: '#'
    },

    triggers: {
        set_active_tab__noop: 'set_active_tab'
    },

    events: {
        click: 'on_click'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onRender: function () {
        var extra_classes = this.model.get('tab_class');
        var new_classes = `${this.className} ${extra_classes}`;

        if (this.$el.hasClass('active')) {
            new_classes += ' active';
        }

        this.$el.attr('class', new_classes);
    },

    on_click: function (event) {
        this.trigger('set_active_tab', this);
        return false;
    }
});

export const TabbedNav = Backbone.Marionette.CompositeView.extend({
    template: '#tpl_tabbed_nav',
    className: 'tabbed_nav',

    collection: null, // TabbedLayoutPageList
    itemView: TabbedNavItem,
    itemViewContainer: '.tabs_list',
    itemViewEventPrefix: 'tab',

    is_tabs_full_width: false,
    active_tab_id: null,
    CLASSNAME_TABS_FULL_WIDTH: 'is_tabs_full_width',

    on_tab_selected: function (model) {}, // callback from caller

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        var this_ = this;
        if (this.is_tabs_full_width) {
            // if using full-width tabs, we need to recompute the active nav marker when the device is rotated
            this.listenTo($f.application.vent, 'app:orientation_change', function () {
                this_._adjust_nav_marker();
            });
        }
    },

    onShow: function () {
        this.render(); // @todo:marionette_showrender @jira:INF-559
    },

    onRender: function () {
        if (!this._isShown) {
            return;
        }

        if (!this.collection.length) {
            return; // we should never have 0 tabs
        }

        if (!this.$el.outerWidth(true)) {
            throw new Error('Programmer Error: TabbedNav calculating tab widths before attaching to DOM');
        }

        if (this.is_tabs_full_width) {
            this.$el.addClass(this.CLASSNAME_TABS_FULL_WIDTH);
        } else {
            this.$el.removeClass(this.CLASSNAME_TABS_FULL_WIDTH);
        }

        var this_ = this;
        this.off('tab:set_active_tab');
        this.on('tab:set_active_tab', function (view) {
            this_.set_active_tab(view);
        });

        // Check if we have an active tab saved and its a part of the current list of pages
        if (this.active_tab_id && this.collection.get(this.active_tab_id)) {
            this.set_active_tab(this.children.findByModel(this.collection.get(this.active_tab_id)));
            return;
        }

        this.set_active_tab(this.children.first());
    },

    set_active_tab: function (view) {
        this.active_tab_id = view.model.id;
        this.$el.find('.active').removeClass('active');
        view.$el.addClass('active');
        this._adjust_nav_marker();
        this.on_tab_selected(view.model);
    },

    /**
     * Animates the nav marker for the nav buttons to the currently active nav item.
     *
     * This will also animate the scrollable div left/right sliglhtly when a tab is chosen so that
     * the user is aware that they can scroll.
     */
    _adjust_nav_marker: function () {
        var $active = this.$el.find('.active');
        var distance_from_edge_to_active = $active.position().left - $active.parent().position().left;

        // Scroll a little bit left or right whenver a tab is chosen

        // distance is the total distance we have to do / 3, so if each tab is 100px, roughly 30 px per tab
        var distance = ($active.offset().left - this.$el.find('.nav_marker').offset().left) / 3;
        var target_scroll_left = $active.parents('.tabbed_nav').scrollLeft() + distance;

        // @author:david Alternative approach to above: always try to center the active tab. Leaving this
        // here in case we want to adjust our approach in the future:
        //
        // var active_center = distance_from_8edge_to_active + $active.outerWidth() / 2;
        // var tabbed_nav_width = this.$el.outerWidth() / 2
        // var target_scroll_left = active_center - tabbed_nav_width;

        this.$el.find('.nav_marker').css({
            // animation is handled by CSS3
            left: distance_from_edge_to_active + 'px',
            width: $active.outerWidth(true)
        });

        if ($active.is(':first-child')) {
            target_scroll_left = 0; // there's some weird margin on the first one, so it's just easier to scroll to 0
        }

        this.$el.animate(
            {
                scrollLeft: target_scroll_left
            },
            200
        );
    }
});

export const TabbedLayoutPages = Backbone.Marionette.CollectionView.extend({
    collection: null, // TabbedLayoutPageList

    /**
     * Rather than using up the itemView.model namespace, we'll send it a __tabbed_nav_page_lists_item instead. This
     * allows TabbedLayoutPage-s to use their own model instead of having to worry about the internals of the
     * TabbedLayout system.
     */
    itemViewOptions: function (model, index) {
        return $.extend({}, { __tabbed_nav_page_lists_item: model, model: null }, model.get('view_options') || {});
    },

    getItemView: function (model) {
        var view = model.get('view_class');

        if (!view) {
            throw new Error('Programmer Error: view_class not set on TabbedLayoutPageListItem');
        }

        return view;
    }
});

export const TabbedLayout = Backbone.Marionette.Layout.extend({
    template: '#tpl_tabbed_layout',

    tab_pages: null, // TabbedLayoutPageList
    hide_tabs: false, // Can set to true to hide tabs. we use this for no groups downstate
    is_tabs_full_width: false,
    active_tab_id: null,

    regions: {
        r_tabbed_nav: '.tabbed_nav_container',
        r_tab_pages: '.tabbed_layout_pages'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onShow: function () {
        this.render(); // @todo:marionette_showrender @jira:INF-559
    },

    onRender: function () {
        if (!this._isShown) {
            return;
        }

        var this_ = this;

        this.r_tab_pages.show(
            new TabbedLayoutPages({
                collection: this.tab_pages
            })
        );

        if (this.hide_tabs) {
            return;
        }

        this.r_tabbed_nav.show(
            new TabbedNav({
                collection: this.tab_pages,
                is_tabs_full_width: this.is_tabs_full_width,
                active_tab_id: this.active_tab_id,
                on_tab_selected: (tab) => {
                    this.jump_to_page(tab.id, true, true);
                    this.trigger('change_active_tab', tab.id);
                }
            })
        );

        this.stopListening($f.application.vent, 'app:orientation_change');
        this.listenTo($f.application.vent, 'app:orientation_change', function () {
            // Make sure we jump to page here to realign tab elements after orientation change
            this_.jump_to_page(this_.active_tab_id, false, false);
        });

        // this jumps to the page set via $f.mobile.dashboard.active_tab_id with animation
        this.listenTo($f.application.vent, 'tabbed_layout:jump_to_page', function (new_tab_id) {
            this_.active_tab_id = new_tab_id;

            var tabbed_nav = this_.r_tabbed_nav.currentView;

            // setting the active tab ensures that the ui elements change if we're not reloading the dashboard;
            tabbed_nav.set_active_tab(tabbed_nav.children.findByModel(tabbed_nav.collection.get(this_.active_tab_id)));

            // dont do the focus_events since the set_active_tab call above already does this
            this_.jump_to_page(this_.active_tab_id, true, false);
        });
    },

    jump_to_page: function (page_id, animate, do_focus_events) {
        var this_ = this;

        if (!page_id) {
            return;
        }

        animate = animate !== false; // default true
        do_focus_events = do_focus_events !== false; // default true
        var ANIMATION_TIME_MS = 420 / 2;

        var page_model = this.tab_pages.get(page_id);

        if (!page_model) {
            return;
        } // just in case

        var $tabbed_layout_pages = this.$el.find('.tabbed_layout_pages');

        var target_view = this.r_tab_pages.currentView.children.find(function (item) {
            return item.__tabbed_nav_page_lists_item.get('id') === page_id;
        });

        if (!target_view) {
            throw new Error('Programmer Eror: unable to find TabbedLayout page ' + page_id);
        }

        this.active_tab_id = page_id;

        if (do_focus_events) {
            setTimeout(function () {
                // improve performance by waiting for below page animation to finish
                this_.$el.find('.tabbed_layout_page.active').removeClass('active');
                target_view.$el.addClass('active');
                target_view.on_tab_focused();
            }, ANIMATION_TIME_MS);
        }

        $tabbed_layout_pages.velocity(
            {
                translateX: `-${target_view.$el.index() * 100}%`
            },
            {
                duration: animate ? ANIMATION_TIME_MS : 0
            }
        );
    },

    update_tab: function (options) {
        options = options || {};
        var tab;
        if (!options.id) {
            throw new Error('Programmer Error: tab_id is missing from update_tab method');
        }

        if (!options.changes) {
            throw new Error('Programmer Error: changes is missing from update_tab method');
        }

        tab = this.tab_pages.get(options.id);

        if (!tab) {
            return;
        }

        this.r_tabbed_nav.currentView.children.findByModel(tab).render();
    }
});

export const BaseTabbedLayoutPage = Backbone.Marionette.Layout.extend({
    template: '#tpl_tabbed_layout_page',
    className: 'tabbed_layout_page',
    __tabbed_nav_page_lists_item: null, // TabbedLayoutPageListItem

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    render: function () {
        BaseTabbedLayoutPage.__super__.render.apply(this, arguments);
        var this_ = this;

        this.$el.addClass(this.__tabbed_nav_page_lists_item.id);

        setTimeout(function () {
            $f.mobile.update_page_scrollable_height(this_.$el);
        }, $f.mobile.DELAY_ON_ORIENTATION_CHANGE_MS);
    },

    /**
     * Implement in inherited views to perform custom logic when navigating to a tab.
     */
    on_tab_focused: function () {}
});
